import { render } from "./PdfPreviewAnlagenschema.vue?vue&type=template&id=5152ebd8"
import script from "./PdfPreviewAnlagenschema.vue?vue&type=script&lang=js"
export * from "./PdfPreviewAnlagenschema.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__